import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions, ResponseContentType } from '@angular/http';

import { Tracker }        from '../../shared/entities/tracker';
import { Position }        from '../../shared/entities/position';
import { Observable }     from '../../../node_modules/rxjs/Observable';

import { SERVER_URL } from './server-url';
import { DeliveryPoint } from '../entities/delivery-point';

@Injectable()
export class ReportService {

    private companyUrl = SERVER_URL + '/api/reports/ahura-marker';  // URL to web API
    

    private positionsReportUrl = SERVER_URL + '/api/reports/journeyReportPDFGet';

    private lastPositionsReportUrl = SERVER_URL + '/api/reports/lastPositionsReportPDFGet';  // URL to web API
    
    private deliveryReportUrl = SERVER_URL + '/api/reports/deliveryReportPDFGet';  // URL to web API
    private deliveriesReportUrl = SERVER_URL + '/api/reports/delivery';  // URL to web API
        
    private deliveryPointsReportUrl = SERVER_URL + '/api/reports/delivery/points';  // URL to web API

    constructor (private http: Http) {}

    getPDF(token:any, username:string, tracker_id:number, datetimeInit:Date, datetimeEnd:Date): Observable<any> {
        var mountURL = this.positionsReportUrl;

        if (token && username && tracker_id) {
            mountURL = mountURL + '?token=' + token + 
                                    '&username=' + username + 
                                    '&tracker_id=' + tracker_id;
        }
        
        if (datetimeInit) {
            
            var month:number = datetimeInit.getMonth() + 1;
            var day:number = datetimeInit.getDate();
            var minutes:number = datetimeInit.getUTCMinutes();
            var hours:number = datetimeInit.getHours();
            
            // mountURL = mountURL + '&datetimeInit=' + datetimeInit.toString();

         
            mountURL = mountURL + '&datetimeInit=' 
                    + datetimeInit.getFullYear() 
                    + '-' + month
                    + '-' + day
                    + ' ' + hours
                    + ':' + minutes;

            if (datetimeEnd) {
                var monthEnd:number = datetimeEnd.getMonth() + 1;
                var dayEnd:number = datetimeEnd.getDate();
                var minutesEnd:number = datetimeEnd.getUTCMinutes();
                var hoursEnd:number = datetimeEnd.getHours();
               
                mountURL = mountURL + '&datetimeEnd=' 
                    + datetimeEnd.getFullYear() 
                    + '-' + monthEnd
                    + '-' + dayEnd
                    + ' ' + hoursEnd
                    + ':' + minutesEnd;
            }
        }

       let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
       return this.http.get(mountURL, { responseType: ResponseContentType.Blob })
                        .map((res) => {
                                return new Blob([res.blob()], { type: 'application/pdf' })
                            })
                        .catch(this.handleError);
    } 

    resultPDF (res:any) { 
        this.downloadFile(res._body);
        return res; 
    }

    downloadFile(data: any) {
        var blob = new Blob([data], { type: 'application/pdf' });
        var url= window.URL.createObjectURL(blob);
        window.open(url);
    }

    downloadExcel(data: any, fileName:string) {
        console.log('XLS GERADO');

        var a = document.createElement("a");
                
        document.body.appendChild(a);
        
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
    }

    downloadCSV(data: any, fileName:string) {
      
        var blob = new Blob([data], { type: 'text/csv' });
        var link = window.document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        // Construct filename dynamically and set to link.download
        link.download = fileName; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);


        //var url= window.URL.createObjectURL(blob);
        //window.open(url);
    }

    generateFilenameWithDate(fileName:string, fileType:string, username:string) {
        var dateNow = new Date();
        var monthEnd:number = dateNow.getMonth() + 1;
        var dayEnd:number = dateNow.getDate();
        var minutesEnd:number = dateNow.getUTCMinutes();
        var hoursEnd:number = dateNow.getHours();
        var secondsEnd:number = dateNow.getSeconds();
       
        var dateName = dateNow.getFullYear() 
            + '-' + monthEnd
            + '-' + dayEnd
            + '_' + hoursEnd
            + '-' + minutesEnd
            + '-' + secondsEnd;

        return fileName + '-' + username + '-' + dateName + '.' + fileType;
    }

    getLastPositionsPDF(token:any, username:string): Observable<any> {
        var mountURL = this.lastPositionsReportUrl;

        if (token && username) {
            mountURL = mountURL + '?token=' + token + 
                                    '&username=' + username 
        }
        
       let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
       return this.http.get(mountURL, { responseType: ResponseContentType.Blob })
                        .map((res) => {
                                return new Blob([res.blob()], { type: 'application/pdf' })
                            })
                        .catch(this.handleError);
    }

    //** SUGESTÃO: Passar o objeto Delivery inteiro
    // pois já tem mais informações para serem exportadas no relatório (ex: totais) */
    getDeliveryReportPDF(token:any, username:string, deliveryID:any, orders:any[], deliveryPoints:DeliveryPoint[]): Observable<any> {
        var mountURL = this.deliveryReportUrl;
        var auxOrdersID:any = [];

        for (var i = 0; i < orders.length; i++){
            auxOrdersID.push(orders[i].id);
        }

        if (token && username) {
            mountURL = mountURL + '?token=' + token + 
                                    '&username=' + username  +
                                    '&delivery_id=' + deliveryID +
                                    '&orders=' + JSON.stringify(auxOrdersID);
        }       
        
        // console.log(JSON.stringify(orders));
       let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
       return this.http.get(mountURL, { responseType: ResponseContentType.Blob , body: orders})
                        .map((res) => {
                                return new Blob([res.blob()], { type: 'application/pdf' })
                            })
                        .catch(this.handleError);
    }


    getExportReportDeliveries(token:string, username:string, init:Date, end:Date, isDelivery:boolean, isVehicle:boolean, isCollaborator:boolean) {
        
        var mountURL = this.deliveriesReportUrl;
        mountURL += `?initDate=${init}&endDate=${end}&isDelivery=${isDelivery}&isVehicle=${isVehicle}&isCollaborator=${isCollaborator}`;


        let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        headers.append('Authorization', 'JWT ' + token);

       return this.http.get(mountURL, { headers: headers, responseType: ResponseContentType.Blob , body: null})
                        .map((res) => {
                                var fileName = this.generateFilenameWithDate('entregas', 'xlsx', username);
                                var file = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                                this.downloadExcel(file, fileName);                                
                        })
                        .catch(this.handleError);
    }

    getExportReportDeliveryPoints(token:string, username:string, deliveryId:number) {
        
        var mountURL = this.deliveryPointsReportUrl;
        mountURL += `?deliveryId=${deliveryId}`;


        let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        headers.append('Authorization', 'JWT ' + token);

       return this.http.get(mountURL, { headers: headers, responseType: ResponseContentType.Blob , body: null})
                        .map((res) => {
                                var fileName = this.generateFilenameWithDate('pontos-entregas', 'xlsx', username);
                                var file = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                                this.downloadExcel(file, fileName);                                
                        })
                        .catch(this.handleError);
    }

    getVisitReportPDF() { return null; }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }

    exportCompaniesReport(token:string, username:string, fileType:string) {
        var requestOptions;

        if (fileType == 'csv') {
            requestOptions = { headers : new Headers({'Content-Type': 'text/csv'}) };        
        } else if (fileType == 'xlsx') {
            requestOptions = { headers : new Headers(), responseType: ResponseContentType.Blob };
        }
    
        requestOptions.headers.append('Authorization', 'JWT ' + token);
        
        var url = this.companyUrl;
        url += '?fileType=' + fileType;

        return this.http.get(url, requestOptions)
                    .map((res) => {
                        var fileName = this.generateFilenameWithDate('clientes', fileType, username);

                        if (fileType == 'csv') {
                            this.downloadCSV(res.text(), fileName);
                        } else {
                            var resultBlob = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            this.downloadExcel(resultBlob, fileName);
                            //return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

                            //
                            //return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        }
                    })
                    .catch(this.handleError);
    }

}




// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/report.service.ts